<template>
  <div class="ihk-search flex-col md:flex-row-reverse w-full md:w-auto">
    alsdkjfklasjdf
    <div class="search-area w-full flex justify-between items-center">
      <div class="relative">
        <input type="text" placeholder="Wonach suchst du?" v-model="query" @keyup="handleKeyup" @blur="handleBlur" @click="handleClick">
        <ul class="result-list" v-show="results.length">
          <li v-for="(result, index) in results" v-if="index < 8">
            <a :href="result.link">{{ getNameOf(result) | decodeHTML }}</a>
          </li>
        </ul>
      </div>
      <i class="fas fa-search ml-4 text-lg" @click="search"></i>
      <i class="fas fa-times ml-4 text-xl text-grey-700" @click="closeSearch"></i>
    </div>

    <div class="types flex justify-between md:mr-3">
      <div @click="setType('themes')" class="type" :class="{'active-type' : activeType === 'themes'}">Themen</div>
      <div @click="setType('jobs')" class="type" :class="{'active-type' : activeType === 'jobs'}">Berufe</div>
      <div @click="setType('dual')" class="type" :class="{'active-type' : activeType === 'dual'}">Duales Studium</div>
      <div @click="setType('companies')" class="type" :class="{'active-type' : activeType === 'companies'}">Firmen</div>
    </div>
  </div>
</template>

<script>
    import axios from 'axios';
    import _ from 'lodash';

    export default {
        data() {
            return {
                query: "",
                activeType: "themes",
                results: []
            }
        },

        methods: {
            handleBlur(event) {
                // Clear results so suggestions arent shown anymore
                // SetTimout to make sure that a click can be registered after blur before clearing the results
                setTimeout(() => {
                    this.results = [];
                }, 150);
            },

            handleClick() {
               if (this.query) this.search();
            },

            setType(type) {
                this.activeType = type;
            },

            async search() {
                const apiUrl = '/wp-json/wp/v2/';

                if (this.activeType === 'themes') {
                    const {data} = await axios.get(apiUrl + 'thema?search=' + this.query);
                    this.results = data;
                }

                if (this.activeType === 'jobs') {
                    const {data} = await axios.get(apiUrl + 'job?search=' + this.query);
                    this.results = data;
                }

                if (this.activeType === 'dual') {
                    const {data} = await axios.get(apiUrl + 'job?dual=true&search=' + this.query);
                    this.results = data;
                }

                if (this.activeType === 'companies') {
                    const {data} = await axios.get(apiUrl + 'company?search=' + this.query);
                    this.results = data;
                }
            },

            handleKeyup(event) {
                if (event.key === 'Enter') return this.goToSearchResults();

                if (!this.query.length) return;
                this.search();
            },

            closeSearch() {
                // Sends an event up to ihk-header, which then hides the search
                this.$emit('close');
                this.query = '';
                this.results = [];
            },

            getNameOf(result) {
                if (result.name) return result.name;
                if (!result.title) return;

                return result.title.rendered;
            },

            goToSearchResults() {
                let url = window.location.origin + '?s=' + this.query;

                // Add post type to search URL
                if (this.activeType === 'jobs') url += '&post_type=job';
                if (this.activeType === 'dual') url += '&post_type=job&dual=true';
                if (this.activeType === 'companies') url += '&post_type=company';

                // Since the default WordPress search cant search for taxonomies, we will handle
                // The results on the archive page for this taxonomy
                if (this.activeType === 'themes') url = '/themen?s=' + this.query;

                window.location.replace(url);
            },
        },

        watch: {
            // Make sure the result-list is reset to nothing when the user deletes the query
            query(newQuery, oldQuery) {
                if (!newQuery) {
                    this.results = [];
                }
            }
        },

        filters: {
            decodeHTML(string) {
                let map = {"gt": ">" /* , … */};
                return string.replace(/&(#(?:x[0-9a-f]+|\d+)|[a-z]+);?/gi, function ($0, $1) {
                    if ($1[0] === "#") {
                        return String.fromCharCode($1[1].toLowerCase() === "x" ? parseInt($1.substr(2), 16) : parseInt($1.substr(1), 10));
                    } else {
                        return map.hasOwnProperty($1) ? map[$1] : $0;
                    }
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
  .ihk-search {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2000;
    background: white;
    height: 100%;
    display: flex;
    align-items: center;

    .search-area {
      padding: 0px 20px 10px 20px;

      @media only screen and (min-width: 764px) {
        padding: 10px 20px 10px 0px;
      }

      input[type='text'] {
        background-color: #FAFAFA;
        border: 1px solid #EFEFEF;
        border-radius: 4px;
        font-size: 17px;
        padding: 6px 12px;
        margin-bottom: 8px;
        flex-grow: 3;

        @media only screen and (min-width: 764px) {
          width: 400px;
          margin-bottom: 0px;
        }
      }

      i {
        cursor: pointer;

        &.fa-search {
          color: #0F5488;
        }
      }


      .result-list {
        position: absolute;
        top: 38px;
        left: 0px;
        width: 100%;
        border: 1px solid #EFEFEF;
        background-color: white;
        border-radius: 0px 0px 4px 4px;
        box-shadow: 2px 4px 4px 0px rgba(0, 0, 0, 0.075);

        li {
          padding: 8px 15px;
          border-bottom: 1px solid #EFEFEF;
          cursor: pointer;

          &:hover {
            background-color: #EFEFEF;
          }
        }

        li:last-child {
          border: none;
        }
      }
    }

    .types {
      background-color: #F7F7F7;
      width: 100%;
      padding: 10px 20px;

      @media only screen and (min-width: 764px) {
        background-color: transparent;
        padding: 10px 8px 10px 8px;
      }

      @media only screen and (max-width: 475px) {
        flex-direction: column;
        box-shadow: 0px 2px 3px rgba(0,0,0,0.15);
      }

      .type {
        background-color: #F7F7F7;
        border: 1px solid #C3C3C3;
        border-radius: 4px;
        padding: 6px 15px;
        font-size: 17px;
        color: #8E8E8E;
        margin-left: 4px;
        margin-right: 4px;
        cursor: pointer;

        @media only screen and (max-width: 475px) {
          margin: 2px 0px;
        }
      }

      .active-type {
        background-color: #0093D3;
        color: white;
        border-color: #0093D3;
      }
    }
  }
</style>
